(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  async function load(){
    const content=document.getElementById('ims-users-content');
    if(!content)return;
    const showInactive = document.getElementById('ims-users-show-inactive')?.checked || false;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const {data:users,error}=await db().select('users',{order:{col:'name'}});
    if(error){content.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-user-cog"></i><h3>Failed to load users</h3><p>${error.message}</p></div>`;return;}
    const showInactiveToggle = document.getElementById('ims-users-show-inactive')?.checked || false;
    const items=(users||[]).filter(u => showInactiveToggle || (u.is_active && !u.name?.startsWith('[Deleted]')));
    content.innerHTML=`
      <div style="display:flex;justify-content:flex-end;margin-bottom:10px">
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;color:var(--ims-text-muted);cursor:pointer">
          <input type="checkbox" id="ims-users-show-inactive" onchange="window.IMS_USERS.load()">
          Show deleted/inactive users
        </label>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Last login</th><th>Status</th><th></th></tr></thead>
            <tbody>${items.map(u=>`<tr>
              <td>
                <div style="display:flex;align-items:center;gap:8px">
                  <div style="width:28px;height:28px;border-radius:50%;background:var(--ims-accent);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#fff;flex-shrink:0">${util().initials(u.name||u.email)}</div>
                  <span style="font-weight:500">${util().sanitize(u.name||'—')}</span>
                  ${u.id===window.SM.AUTH.user?.id?'<span class="ims__pill ims__pill--info" style="font-size:10px">You</span>':''}
                </div>
              </td>
              <td style="font-size:12px">${util().sanitize(u.email||'—')}</td>
              <td>
                <span class="ims__pill ims__pill--${u.role==='super_admin'||u.role==='admin'?'info':u.role==='viewer'?'neutral':'accent'}" style="font-size:11px">${util().formatRole(u.role)}</span>
              </td>
              <td style="font-size:12px;color:${u.last_login?'var(--ims-text)':'var(--ims-text-muted)'}">${u.last_login?util().formatDateTime(u.last_login):'Never logged in'}</td>
              <td>
                ${u.id!==window.SM.AUTH.user?.id?`
                  <label style="display:flex;align-items:center;gap:8px;cursor:pointer">
                    <div style="position:relative;width:40px;height:22px;flex-shrink:0">
                      <input type="checkbox" ${u.is_active?'checked':''} style="opacity:0;width:0;height:0;position:absolute"
                        onchange="window.IMS_USERS.toggleActive('${u.id}',this.checked,'${util().sanitize(u.name||u.email)}')">
                      <div style="position:absolute;inset:0;border-radius:999px;background:${u.is_active?'var(--ims-success)':'var(--ims-border2)'};transition:.2s"></div>
                      <div style="position:absolute;top:3px;left:${u.is_active?'21':'3'}px;width:16px;height:16px;border-radius:50%;background:#fff;transition:.2s;box-shadow:0 1px 3px rgba(0,0,0,.2)"></div>
                    </div>
                    <span style="font-size:12px;color:${u.is_active?'var(--ims-success)':'var(--ims-text-muted)'}">${u.is_active?'Active':'Inactive'}</span>
                  </label>`
                :`<span class="ims__pill ims__pill--success">Active</span>`}
              </td>
              <td>
                <div class="ims__btn-group">
                  ${u.id!==window.SM.AUTH.user?.id?`
                    <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_USERS.editUser('${u.id}')" title="Edit role"><i class="ti ti-edit"></i></button>
                    <button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_USERS.deleteUser('${u.id}','${util().sanitize(u.name||u.email)}')" title="Delete user"><i class="ti ti-trash"></i></button>
                  `:''}
                </div>
              </td>
            </tr>`).join('')||'<tr><td colspan="6" class="ims__table-empty">No users found</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  function showForm(existingId=null,userData=null){
    const isEdit=!!existingId;
    const roles=[
      {value:'super_admin',label:'Super Admin — Full system access'},
      {value:'admin',label:'Admin — All modules, user management'},
      {value:'imports_manager',label:'Imports Manager — Imports only'},
      {value:'warehouse_manager',label:'Warehouse Manager — Warehouse, logistics, inventory'},
      {value:'warehouse_staff',label:'Warehouse Staff — Stock and warehouse'},
      {value:'order_management',label:'Order Management — Orders, customers, logistics'},
      {value:'logistics_staff',label:'Logistics Staff — Logistics only'},
      {value:'accounts_staff',label:'Accounts Staff — Accounts and reports'},
      {value:'viewer',label:'Viewer — Read only'},
      {value:'custom',label:'Custom — choose specific modules'}
    ];
    const modules=[
      {key:'dashboard',label:'Dashboard'},
      {key:'customers',label:'Customers'},
      {key:'inventory',label:'Inventory'},
      {key:'orders',label:'Orders'},
      {key:'purchases',label:'Purchases'},
      {key:'imports',label:'Imports'},
      {key:'warehouse',label:'Warehouse'},
      {key:'logistics',label:'Logistics'},
      {key:'dropship',label:'Dropship'},
      {key:'accounts',label:'Accounts'},
      {key:'reports',label:'Reports'},
      {key:'deals',label:'Deals'},
      {key:'company',label:'Company setup'},
      {key:'platforms',label:'Platforms'},
      {key:'users',label:'Users'},
      {key:'backup',label:'Backup & restore'}
    ];
    const selectedModules=new Set(userData?.custom_permissions||[]);
    const isCustom=userData?.role==='custom';
    ui().openModal(isEdit?`Edit user: ${userData?.name||''}`:'Add user',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Full name</label><input class="ims__input" type="text" id="ims-usr-name" value="${util().sanitize(userData?.name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Email address</label><input class="ims__input" type="email" id="ims-usr-email" value="${util().sanitize(userData?.email||'')}" ${isEdit?'readonly style="background:var(--ims-surface2)"':''}></div>
        <div class="ims__form-group ims__form-group--full">
          <label class="ims__label ims__label--req">Role</label>
          <select class="ims__select" id="ims-usr-role" onchange="window.IMS_USERS.onRoleChange()">
            ${roles.map(r=>`<option value="${r.value}" ${userData?.role===r.value?'selected':''}>${r.label}</option>`).join('')}
          </select>
        </div>
        <div class="ims__form-group ims__form-group--full" id="ims-usr-modules-wrap" style="${isCustom?'':'display:none'}">
          <label class="ims__label">Module access</label>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;max-height:260px;overflow-y:auto;border:1px solid var(--ims-border);border-radius:var(--ims-radius);padding:10px">
            ${modules.map(m=>`
              <label style="display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer;padding:4px 2px">
                <input type="checkbox" class="ims-usr-module-cb" value="${m.key}" ${selectedModules.has(m.key)?'checked':''}>
                ${m.label}
              </label>`).join('')}
          </div>
          <span class="ims__input-hint">Tick every module this user should be able to see and use. Admin-only destructive actions (e.g. deleting records) still require the Super Admin or Admin role, regardless of module access.</span>
        </div>
        ${!isEdit?`
          <div class="ims__form-group ims__form-group--full">
            <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
              <span>The user will need to set their password via Supabase Auth or you can set it manually in Supabase Authentication → Users.</span>
            </div>
          </div>` : ''}
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_USERS.saveUser('${existingId||''}')"><i class="ti ti-check"></i> ${isEdit?'Save changes':'Add user'}</button>
    `,'sm');
  }

  function onRoleChange(){
    const role=document.getElementById('ims-usr-role')?.value;
    const wrap=document.getElementById('ims-usr-modules-wrap');
    if(wrap) wrap.style.display=role==='custom'?'':'none';
  }

  async function editUser(id){
    const {data:u}=await db().select('users',{eq:{id},maybeSingle:true,noCompanyFilter:true});
    if(!u)return;
    showForm(id,u);
  }

  async function saveUser(existingId){
    const name=document.getElementById('ims-usr-name')?.value?.trim();
    const email=document.getElementById('ims-usr-email')?.value?.trim();
    const role=document.getElementById('ims-usr-role')?.value;
    if(!name){ui().toast('Name is required','error');return;}
    if(!email){ui().toast('Email is required','error');return;}
    if(!role){ui().toast('Role is required','error');return;}

    // Always computed explicitly (empty array for non-custom roles) so
    // that switching a user away from Custom clears any stale selections,
    // rather than leaving old permissions dormant in the database.
    const customPermissions = role==='custom'
      ? [...document.querySelectorAll('.ims-usr-module-cb:checked')].map(cb=>cb.value)
      : [];
    if(role==='custom' && !customPermissions.length){
      ui().toast('Please tick at least one module for a Custom role','error');
      return;
    }

    if(existingId){
      const {error}=await db().update('users',existingId,{name,role,custom_permissions:customPermissions});
      if(error){ui().toast('Failed: '+error.message,'error');return;}
      ui().closeModal();ui().toast('User updated','success');load();
    } else {
      // Check email not already in use
      const {data:existing}=await db().select('users',{eq:{email},maybeSingle:true});
      if(existing){ui().toast('A user with this email already exists','error');return;}

      // Send Supabase invitation email
      const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
      const {data:inviteData,error:inviteError}=await client.auth.admin?.inviteUserByEmail?.(email,{
        data:{name,role},
        redirectTo:`${window.location.origin}/pages/stock-maestro-portal`
      }).catch(()=>({data:null,error:{message:'Invite API not available from browser'}})) || {data:null,error:{message:'Invite API not available'}};

      // Create user record regardless — auth link done separately if invite fails
      const {data:newUser,error}=await db().insert('users',{name,email,role,is_active:true,custom_permissions:customPermissions});
      if(error){ui().toast('Failed: '+error.message,'error');return;}

      ui().closeModal();
      if(inviteError){
        // Invite API requires service role — show manual instructions
        ui().openModal('User added — password setup required',`
          <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
            <span>User <strong>${util().sanitize(name)}</strong> has been added. To set their password:</span>
          </div>
          <ol style="font-size:13px;color:var(--ims-text-sec);line-height:2;margin:14px 0 0 16px">
            <li>Go to <strong>app.supabase.com</strong> → your project</li>
            <li>Click <strong>Authentication</strong> → <strong>Users</strong></li>
            <li>Click <strong>Invite user</strong></li>
            <li>Enter email: <strong>${util().sanitize(email)}</strong></li>
            <li>Supabase sends them an invite link to set their password</li>
            <li>Once they accept, come back here and their Last login will update</li>
          </ol>
          <div class="ims__alert ims__alert--warning" style="margin-top:12px"><i class="ti ti-alert-triangle"></i>
            <span>The user account in StockMaestro is created. They just need to set their Supabase Auth password to log in.</span>
          </div>
        `,`<button class="ims__btn ims__btn--primary" onclick="window.SM.UI.closeModal()">Got it</button>`,'sm');
      } else {
        ui().toast(`Invitation email sent to ${email}. They will receive a link to set their password.`,'success',6000);
      }
      load();
    }
  }

  async function toggleActive(id,newActive,name){
    ui().confirm(
      `${newActive?'Activate':'Deactivate'} user "${name}"? ${newActive?'They will be able to log in again.':'They will no longer be able to log in.'}`,
      async ()=>{
        const {error}=await db().update('users',id,{is_active:newActive});
        if(error){ui().toast('Failed: '+error.message,'error');return;}
        ui().toast(`User ${newActive?'activated':'deactivated'}`,'success');
        load();
      },
      newActive?'Activate':'Deactivate',
      !newActive
    );
  }

  async function deleteUser(id, name){
    ui().confirm(
      `Permanently delete user "${name}"? This cannot be undone. Their data and audit records will be retained but they will no longer be able to log in.`,
      async () => {
        const {error} = await db().update('users', id, {is_active: false, email: `deleted_${Date.now()}_${id}@deleted.com`, name: `[Deleted] ${name}`});
        if(error){ ui().toast('Failed: '+error.message,'error'); return; }
        ui().toast(`User "${name}" deleted`,'success');
        load();
      },
      'Delete user',
      true
    );
  }

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='users')load();});
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-users-new-btn')?.addEventListener('click',()=>showForm());
  });
  window.IMS_USERS={load,showForm,editUser,saveUser,onRoleChange,toggleActive,deleteUser};
})();
